module.exports = __webpack_public_path__ + "static/wood-grain-textures-1280x720-29a410dafbf7a2a463b44823c12389db.jpg";